import { useOrgSelfServeInfo } from './useOrgSelfServeInfo';

export const useOrgIsSelfServe = () => {
  const orgInfoQuery = useOrgSelfServeInfo();
  return {
    ...orgInfoQuery,
    data: orgInfoQuery.isInitialLoading ? undefined : !!orgInfoQuery.data,
  };
};
